<app-ci-ordered-multiselect
  [items]="items"
  [selectedIds]="selectedIds"
  [required]="required"
  [invalid]="invalid"
  [errorText]="errorText ?? ''"
  [label]="'personalData.mainFocus' | translate"
  [placeholder]="'personalData.mainFocusPlaceholder' | translate"
  [searchPlaceholder]="'personalData.mainFocusSearch' | translate"
  [emptyLabel]="'personalData.mainFocusEmpty' | translate"
  [summaryTemplate]="'personalData.mainFocusSummary' | translate"
  [orderHeaderLabel]="'personalData.mainFocusOrderHeader' | translate"
  [orderHintLabel]="'personalData.orderHint' | translate"
  [emptyListLabel]="'personalData.mainFocusEmptyList' | translate"
  [addButtonLabel]="'request.buttons.mainFocus' | translate"
  [dragHandleAriaLabel]="'personalData.aria.dragHandle' | translate"
  [maxItems]="maxItems"
  [clearLabel]="'ciSelect.clearSelection' | translate"
  [orderListAriaLabel]="'personalData.aria.dragDropOrderMainFocusAria' | translate"
  [moveUpAriaLabel]="moveUpAriaLabel"
  [moveDownAriaLabel]="moveDownAriaLabel"
  [deleteAriaLabel]="deleteAriaLabel"
  (itemsAdded)="onItemsAdded()"
  (itemsRemoved)="onItemsRemoved($event)"
  (itemRemoved)="onItemRemoved($event)"
  (itemMoved)="onItemMoved($event)"
  (maxExceeded)="onMaxExceeded($event)"
  (selectedIdsChange)="onSelectedIdsChange($event)"
  (addClicked)="onAddClick()"
></app-ci-ordered-multiselect>

<app-request-dialog
  [type]="RequestType.MAINFOCUS"
  modalId="addMainFocus"
  [title]="'request.buttons.mainFocus'"
  [(visible)]="showModal"
  (existingChosen)="onExistingChosen($event)"
></app-request-dialog>
